import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";

const getSites = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `team/site-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        siteData: response.result,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const joinToTeam = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `team/join-to-existing-team/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        siteData: response.result,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const updateTeam = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `team/teammate/${params.team_id}/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        siteData: response.result,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const deleteTeam = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `team/teammate/${
        params.team_id
      }/?reg_code=${utilService.getNetwork()}&user_guid=${params.user_guid}`,
      params,
      apiServiceConstants.DELETE,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        siteData: response.result,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const updateTimeSpan = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `team/update-time-for-team-user/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        siteData: response.result,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

export const setTeamCreation = {
  getSites,
  joinToTeam,
  updateTeam,
  deleteTeam,
  updateTimeSpan,
};
